import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import {
  addCurrencyTypes,
  fetchActiveCurrencies,
  fetchCurrencyDefinitions,
  fetchMonthlyExchangeRates,
  postExchangeRates,
  updateDefaultCurrency,
} from '../routines';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';

export function* fetchActiveCurrenciesSaga() {
  try {
    const url = `${envConfig.APIG_URL}currency/active-currencies`;
    const response = yield call(request, url);
    yield put(fetchActiveCurrencies.success(response));
  } catch (error) {
    yield put(fetchActiveCurrencies.failure({ error }));
  }
}

export function* fetchCurrencyDefinitionsSaga() {
  try {
    const url = `${envConfig.APIG_URL}currency/currency-definitions`;
    const response = yield call(request, url);
    yield put(fetchCurrencyDefinitions.success(response));
  } catch (error) {
    yield put(fetchCurrencyDefinitions.failure({ error }));
  }
}

export function* fetchMonthlyExchangeRatesSaga() {
  try {
    const url = `${envConfig.APIG_URL}currency/exchange-rates`;
    const response = yield call(request, url);
    yield put(fetchMonthlyExchangeRates.success(response));
  } catch (error) {
    yield put(fetchMonthlyExchangeRates.failure({ error }));
  }
}

export function* postExchangeRatesSaga({ payload }) {
  try {
    const url = `${envConfig.APIG_URL}currency/exchange-rates`;
    const config = { method: 'POST', payload };
    const response = yield call(request, url, config);

    yield put(
      postExchangeRates.success({
        response,
        successMessage: SUCCESS_MESSAGES.EDIT_EXCHANGE_RATES,
      })
    );

    yield call(fetchMonthlyExchangeRatesSaga);
  } catch (error) {
    yield put(postExchangeRates.failure({ error }));
  }
}

export function* updateDefaultCurrencySaga({ payload }) {
  try {
    const url = `${envConfig.APIG_URL}currency/update-default-currency`;
    const config = { method: 'POST', payload };
    const response = yield call(request, url, config);

    yield put(
      updateDefaultCurrency.success({
        response,
        successMessage: SUCCESS_MESSAGES.UPDATE_DEFAULT_CURRENCY,
      })
    );
    yield call(fetchActiveCurrenciesSaga);
  } catch (error) {
    yield put(updateDefaultCurrency.failure({ error }));
  }
}

export function* addCurrencyTypesSaga({ payload }) {
  try {
    const url = `${envConfig.APIG_URL}currency/currency-types`;
    const config = { method: 'POST', payload: payload.currencyTypes };
    const response = yield call(request, url, config);

    yield put(
      addCurrencyTypes.success({
        response,
        successMessage: SUCCESS_MESSAGES.ADD_CURRENCY,
      })
    );

    yield call(fetchActiveCurrenciesSaga);
    yield call(fetchMonthlyExchangeRatesSaga);
  } catch (error) {
    yield put(addCurrencyTypes.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchActiveCurrencies.TRIGGER, fetchActiveCurrenciesSaga),
    takeLatest(fetchCurrencyDefinitions.TRIGGER, fetchCurrencyDefinitionsSaga),
    takeLatest(
      fetchMonthlyExchangeRates.TRIGGER,
      fetchMonthlyExchangeRatesSaga
    ),
    takeLatest(updateDefaultCurrency.TRIGGER, updateDefaultCurrencySaga),
    takeLatest(postExchangeRates.TRIGGER, postExchangeRatesSaga),
    takeLatest(addCurrencyTypes.TRIGGER, addCurrencyTypesSaga),
  ]);
}
